module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/thumbs/6-ad8f16de76384cefa702eb295f62f7cc.webp";